export const sizeMap = {
  hint: '0.5rem',
  sm: '1rem',
  md: '1.25rem'
};
export const BADGE_SIZES = Object.keys(sizeMap);
export const BADGE_OVERLAPS = ['circular', 'square'];
export const BADGE_POSITIONS = ['top-right', 'top-left', 'bottom-right', 'bottom-left'];
export const BADGE_VARIANTS = ['notification', 'alert', 'warn', 'positive', 'neutral'];